import { render, staticRenderFns } from "./A7HistoricoIndicador.vue?vue&type=template&id=0abdaf4e&scoped=true&"
import script from "./A7HistoricoIndicador.vue?vue&type=script&lang=js&"
export * from "./A7HistoricoIndicador.vue?vue&type=script&lang=js&"
import style0 from "./A7HistoricoIndicador.vue?vue&type=style&index=0&id=0abdaf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abdaf4e",
  null
  
)

export default component.exports